import apiFetch from '../../apiFetch'

export default function (verracoAnadidas, token) {
  return apiFetch({endPoint: `Bioseguridad/getVerraco`, method: 'POST', body: verracoAnadidas, token: token})
}
